import React from 'react';
import {Modal, Button} from 'semantic-ui-react';
import {connectDynamic} from '../dynamicComponent';
import ReactHtmlParser from 'react-html-parser';

export class BurdenStatement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      title: 'Paperwork Burden Disclosure Notice',
    };
  }
  componentDidMount() {
    if (this.props.title !== undefined) {
      this.setState({title: this.props.title});
    }
  }
  handleCloseButton(evt) {
    evt.preventDefault();
    this.closeModal();
  }

  closeModal = () => {
    this.setState({showModal: false});
  };

  render() {
    const {showModal} = this.state;

    let expirationDate;

    if (this.props.expDate != undefined) {
      expirationDate = (
        <React.Fragment>Expiration date: {this.props.expDate}</React.Fragment>
      );
    }

    return (
      <Modal
        closeIcon
        onClose={this.closeModal}
        open={showModal}
        trigger={
          <div className="ui segment right aligned basic no-padding">
            <small>
              OMB number: {this.props.ombn}, {expirationDate}
              <a
                href="#"
                onClick={() => this.setState({showModal: true})}
                title="View burden statement for Office of Management and Budget (OMB) "
              >
                {' '}
                View burden statement
              </a>
            </small>
          </div>
        }
      >
        <Modal.Header>{this.state.title}</Modal.Header>
        <Modal.Content>
          <p>
            <b>OMB number: {this.props.ombn}</b>
          </p>
          <p>
            <b>{expirationDate}</b>
          </p>
          <p>
            <b>Paperwork Burden Disclosure Notice</b>
          </p>
          <p>{ReactHtmlParser(this.props.text)} </p>
          <Button primary onClick={(evt) => this.handleCloseButton(evt)}>
            Close
          </Button>
        </Modal.Content>
      </Modal>
    );
  }
}
export default connectDynamic(BurdenStatement);
